import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocumentTitle';
import authService from '../services/auth';

const { Title, Text } = Typography;

const ForgotPassword: React.FC = () => {
  useDocumentTitle('找回密码');
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values: { email: string }) => {
    setSubmitting(true);
    try {
      const res = await authService.forgotPassword({ email: values.email });
      if (res.success) {
        message.success(res.message || '重置链接已发送，请检查邮箱');
        navigate('/login');
      } else {
        const detail = res.errors?.email?.[0] || res.message;
        message.error(detail || '发送失败，请稍后再试');
      }
    } catch (error: any) {
      const data = error?.response?.data;
      const detail = data?.errors?.email?.[0] || data?.message;
      message.error(detail || '发送失败，请稍后再试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#eef2f6',
        padding: '24px'
      }}
    >
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <Card style={{ boxShadow: '0 12px 30px rgba(27, 74, 163, 0.15)', borderRadius: '12px' }}>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <Title level={3} style={{ marginBottom: '8px' }}>找回密码</Title>
            <Text type="secondary">输入注册邮箱，我们会发送重置链接</Text>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            autoComplete="off"
            size="large"
          >
            <Form.Item
              label={<span style={{ fontWeight: 600 }}>邮箱</span>}
              name="email"
              rules={[{ required: true, message: '请输入邮箱地址' }, { type: 'email', message: '邮箱格式不正确' }]}
            >
              <Input
                prefix={<MailOutlined style={{ color: '#8c8c8c' }} />}
                placeholder="请输入注册邮箱"
                style={{ height: '48px', borderRadius: '10px' }}
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              block
              style={{ height: '48px', borderRadius: '10px', fontWeight: 700 }}
            >
              发送重置邮件
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;

